import { CardSkeleton, PanelSkeleton, Skeleton, SkeletonGroup } from "@/components/ui/Skeleton";
import styles from "./EditorSkeleton.module.scss";

/** The card area of the editor while the saved design loads. */
export function CanvasSkeleton() {
  return (
    <SkeletonGroup label="Loading your card" className={styles.canvas}>
      <CardSkeleton width="min(22rem, 70%)" />
    </SkeletonGroup>
  );
}

/** Whole editor (top bar, steps, side panels, canvas) while its code chunk loads. */
export function EditorPageSkeleton() {
  return (
    <SkeletonGroup label="Loading the editor" className={styles.page}>
      <span className={styles.topBar}>
        <Skeleton width="7rem" height="1.1rem" />
        <span className={styles.steps}>
          {Array.from({ length: 5 }, (_, i) => (
            <Skeleton key={i} width="5.5rem" height="1.8rem" radius="2rem" />
          ))}
        </span>
        <Skeleton width="7rem" height="2.2rem" radius="0.35rem" />
      </span>
      <span className={styles.body}>
        <span className={styles.side}>
          <PanelSkeleton />
        </span>
        <span className={styles.canvas}>
          <CardSkeleton width="min(22rem, 70%)" />
        </span>
        <span className={styles.side}>
          <PanelSkeleton />
        </span>
      </span>
    </SkeletonGroup>
  );
}
